var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import SlotCard from './SlotCard';
import cxs from 'cxs';
var DayCell = /** @class */ (function (_super) {
    __extends(DayCell, _super);
    function DayCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DayCell.prototype.render = function () {
        var _a = this.props, slots = _a.slots, experienceColor = _a.experienceColor, onSlotClick = _a.onSlotClick;
        if (slots.length === 0) {
            return React.createElement("div", { className: styles.empty }, "Sin horarios");
        }
        return (React.createElement("div", { className: styles.container }, slots.map(function (slot) { return (React.createElement(SlotCard, { key: "".concat(slot.experience_id, "-").concat(slot.date, "-").concat(slot.time), slot: slot, backgroundColor: experienceColor, onClick: function () { return onSlotClick(slot); } })); })));
    };
    DayCell = __decorate([
        observer
    ], DayCell);
    return DayCell;
}(Component));
export default DayCell;
var styles = {
    container: cxs({
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
    }),
    empty: cxs({
        color: '#adb5bd',
        fontSize: '0.8rem',
        textAlign: 'center',
        padding: '20px 0',
    }),
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/components/DayCell.tsx
// module id = 1611
// module chunks = 0